import interceptorAxios from './InterceptorAxios';

const ServicioCorreo={
    
    enviarCorreo(objeto){
        return interceptorAxios.post('/envio_corrreo/enviar_varios_correo.json',objeto);
    },

    enviarAmiCorreo(objeto){
      return interceptorAxios.post('/envio_corrreo/enviar_correo.json',objeto);
    }

}
export default ServicioCorreo;